export const getWeekRange = (dateStr) => {
  const d = new Date(dateStr);
  const month = (d.getMonth() + 1).toString();
  const firstDay = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
  const weekNo = Math.ceil((d.getDate() + firstDay) / 7);
  return `${month}월 ${weekNo}주`;
};

export const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  return `${d.getFullYear().toString().slice(-2)}.${(d.getMonth() + 1).toString().padStart(2, '0')}.${d.getDate().toString().padStart(2, '0')}`;
};

export const transformData = (data, type) => {
  const container = {};
  data.forEach((item) => {
    let key;
    if (type === 'daily')
      key = formatDate(item.date).slice(3); // "MM.DD"
    else if (type === 'weekly') key = getWeekRange(item.date);
    else key = formatDate(item.date).substring(0, 5); // "YY.MM"
    container[key] = (container[key] || 0) + item.count;
  });
  return Object.entries(container).map(([date, count]) => ({ date, count }));
};
